import { render } from "./BlockContent.vue?vue&type=template&id=52045429"
import script from "./BlockContent.vue?vue&type=script&lang=js"
export * from "./BlockContent.vue?vue&type=script&lang=js"
script.render = render

export default script